export default __webpack_public_path__ + "static/media/0065.9959e6f1.jpg";